var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"reduce":(data_option) => data_option.code,"options":_vm.data_option,"label":'name'},on:{"search":_vm.fetchOptions,"input":_vm.selectedOption,"search:focus":_vm.MyFocus},model:{value:(_vm.newselectedValueOption),callback:function ($$v) {_vm.newselectedValueOption=$$v},expression:"newselectedValueOption"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }